import { createSlice } from "@reduxjs/toolkit";
import { getStoredLoggedUser } from "../utils/auth";

const storedLoggedUser = getStoredLoggedUser();

const initialState = {
  setMenuItemsList: [],
  loggedUser: storedLoggedUser || {},
  loading: false,
  error: undefined,
  isAuthenticated: false,
  checking: true,
  hasChecked: false,
};

const securitySlice = createSlice({
  name: "security",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    setMenuItemsList(state, action) {
      state.setMenuItemsList = action.payload;
      state.loading = false;
    },

    // Poziva se nakon uspešnog /auth/me ili /auth/login
    setCurrentUser(state, action) {
      console.log("setCurrentUser reducer");
      state.loggedUser = action.payload || null;
      state.isAuthenticated = !!action.payload;
      state.loading = false;
      state.error = undefined;
      state.checking = false;
      state.hasChecked = true; // ← BITNO
    },

    // Poziva se na logout ili kada /auth/me vrati 401
    clearUser(state) {
      console.log("clearUser reducer");
      state.loggedUser = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = undefined;
      state.checking = false; // ← BITNO
      state.hasChecked = true; // ← BITNO
    },
  },
});

export const securityActions = securitySlice.actions;

export default securitySlice.reducer;
